import { Web3ModalOptions } from '@web3modal/ethers'

export type Web3ChainDefinition = Web3ModalOptions['chains'][number]

export const SEPOLIA_CHAIN: Web3ChainDefinition = {
  chainId: 11155111,
  name: 'Ethereum (Sepolia)',
  currency: 'SepoliaETH',
  explorerUrl: 'https://sepolia.etherscan.io',
  rpcUrl: 'https://ethereum-sepolia-rpc.publicnode.com',
}

export const MAINNET_CHAIN: Web3ChainDefinition = {
  chainId: 1,
  name: 'Ethereum',
  currency: 'ETH',
  explorerUrl: 'https://etherscan.io',
  rpcUrl: 'https://ethereum-rpc.publicnode.com',
}

export const LOCAL_CHAIN: Web3ChainDefinition = {
  chainId: 1337,
  name: 'Localhost 8545',
  currency: 'ETH',
  explorerUrl: '',
  rpcUrl: 'http://localhost:8545',
}

export const DEVNET_CHAIN: Web3ChainDefinition = {
  chainId: 9,
  name: 'Unbounded Network Devnet (L1)',
  currency: 'ETH',
  explorerUrl: 'https://dev-net.unbounded.network:15001/',
  rpcUrl: 'https://dev-net.unbounded.network:15045/',
}

export const DEVNET_ZK_CHAIN: Web3ChainDefinition = {
  chainId: 270,
  name: 'Unbounded Network Devnet (L2)',
  currency: 'ETH',
  explorerUrl: 'https://dev-net.unbounded.network:15005/',
  rpcUrl: 'https://dev-net.unbounded.network:3050/',
}

export const CHAINS = {
  sepolia: SEPOLIA_CHAIN,
  mainnet: MAINNET_CHAIN,
  local: LOCAL_CHAIN,
  devnet: DEVNET_CHAIN,
  devnet_zk: DEVNET_ZK_CHAIN,
}
